import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=6335fe17&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335fe17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6335fe17')) {
      api.createRecord('6335fe17', component.options)
    } else {
      api.reload('6335fe17', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=6335fe17&scoped=true&", function () {
      api.rerender('6335fe17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/views/Detail.vue"
export default component.exports